module.exports = __webpack_public_path__ + "static/media/drum2.6da3f7b3.ogg";